var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMfa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.05393 9.07227C5.68153 5.3645 8.299 4.4916 9.4281 4.49219C10.5572 4.49287 13.0464 5.27026 12.8027 9.07227M6.05393 9.07227H5C3.89543 9.07227 3 9.9677 3 11.0723V17.5098C3 18.6143 3.89543 19.5098 5 19.5098H13.882C14.9866 19.5098 15.882 18.6143 15.882 17.5098V11.0723C15.882 9.9677 14.9866 9.07227 13.882 9.07227H12.8027M6.05393 9.07227H12.8027",
    stroke: "currentColor",
    strokeWidth: 1.5,
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8053 19.5098H19.0014C20.1059 19.5098 21.0014 18.6143 21.0014 17.5098V11.0723C21.0014 9.9677 20.1059 9.07227 19.0014 9.07227H18.1352C18.0197 9.07227 17.9286 8.97257 17.933 8.85717C18.0709 5.24077 15.6549 4.49285 14.5474 4.49219V4.49219C14.2315 4.49219 13.9186 4.55415 13.6265 4.67458L13.6036 4.68404",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    fill: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.57617 14.735L7.84527 15.9862C8.04018 16.1784 8.35337 16.1782 8.54795 15.9857L12.3024 12.2715",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMfa);
export default __webpack_public_path__ + "static/media/MFA.05bd352d10e1f450025ce42517880eeb.svg";
export { ForwardRef as ReactComponent };